/**
 * @fileoverview Renders the toast viewport; must be used inside ToastProvider.
 * @purpose Displays the active toast queue from context (shared ToastContainer).
 * @ownership Shared UI components (core)
 */
'use client';

import { useContext } from 'react';

import { ToastContainer } from '../shared/Toast/ToastContainer';
import { ToastContext } from '../shared/Toast/ToastProvider';

export function Toaster() {
  const context = useContext(ToastContext);
  if (context === undefined || context === null) {
    return null;
  }
  const { toasts, removeToast } = context;
  return <ToastContainer toasts={toasts} onRemove={removeToast} />;
}
